import React from 'react';
import { BookHeart, CalendarSync, House, Landmark, LogOut, MessageSquareWarning, Send, User, Users } from 'lucide-react';
import { useCookies } from 'react-cookie';

const TopNavBar = (props: { activePage: string, onPageChange: (page: string) => void }) => {
    const [cookies, setCookie] = useCookies();
    return (
        <nav style={{ backgroundColor: "#7A6EC7", color: "white" }} className="bg-white shadow-sm border-b border-gray-200">
            <div style={{ color: "#232323" }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo/Brand */}
                    <div style={{ display: "flex", flexDirection: "row" }} className="flex-shrink-0">
                        <h1 style={{ color: "white" }} className="text-xxl font-bold text-gray-900">Joona Dashboard</h1>
                        <span style={{ fontSize: 8, fontWeight: "bold", marginLeft: 6 }} >v1.0</span>
                    </div>

                    {/* Navigation Items */}
                    <div

                        style={{ color: props.activePage === "dashboard" ? "white" : undefined, cursor: "pointer" }}
                        onClick={() => props.onPageChange("dashboard")}
                        className="flex items-center space-x-8">
                        <House size={20} />
                        <span>Home</span>
                    </div>
                    <div
                        onClick={() => props.onPageChange("user")}
                        style={{ color: props.activePage === "user" ? "white" : undefined, cursor: "pointer" }}
                        className="flex items-center space-x-8">

                        <Users size={20} />
                        <span>Users</span>
                    </div>
                    <div
                        style={{ color: props.activePage === "financial" ? "white" : undefined, cursor: "pointer" }}
                        onClick={() => props.onPageChange("financial")}
                        className="flex items-center space-x-8">

                        <Landmark size={20} />
                        <span>Financials</span>

                    </div>
                    <div
                        style={{ color: props.activePage === "subscription" ? "white" : undefined, cursor: "pointer" }}
                        onClick={() => props.onPageChange("subscription")}
                        className="flex items-center space-x-8">
                        <CalendarSync size={20} />
                        <span>Subscriptions</span>
                    </div>
                    <div
                        style={{ color: props.activePage === "engine" ? "white" : undefined, cursor: "pointer" }}
                        onClick={() => props.onPageChange("engine")}
                        className="flex items-center space-x-8">
                        <MessageSquareWarning size={20} />
                        <span>Apple Server Notifications</span>
                    </div>
                    {/*    <div
                        style={{ color: props.activePage === "emails" ? "white" : undefined }}
                        onClick={() => props.onPageChange("emails")}
                        className="flex items-center space-x-8">
                        <Send size={20} />
                        <span>Communications</span>
                    </div> */}
                    <div
                        style={{ color: props.activePage === "emails" ? "white" : "darkred", fontWeight: "bold", fontSize: 12, cursor: "pointer" }}
                        onClick={() => {
                            setCookie("accessToken", undefined);
                            setCookie("refreshToken", undefined);
                            props.onPageChange("root");
                        }
                        }
                        className="flex items-center space-x-8">
                        <LogOut size={20} />
                        <span>Logout</span>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default TopNavBar;